<template>
  <div class="notification-wrapper">
    <div class="notification__pop__block">
      <div v-for="(notification, index) in announcements" :key="'notif_' + index" class="list">
        <img src="@/assets/images/calendar.webp" alt="Calendar" />
        <div class="time">
          <span>{{ renderDateTime(notification.publishDateTime, 'date') }}</span>
          <span>{{ renderDateTime(notification.publishDateTime, 'time') }}</span>
        </div>
        <div class="desc-wrapper">
          <div class="desc">{{ notification.message }}</div>
          <!-- <div v-if="(index === 0 || notification.toLink) && enableJackpot" class="redirect-link" @click="openPopup">
            {{ $t('To read more') }} ->
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { PopupPage } from '@/utils/index.model';

export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters('announcement', ['announcements']),
    ...mapGetters('general', ['timezone', 'enableJackpot']),
  },
  methods: {
    ...mapActions('menu', ['updateMenu']),
    renderDateTime(value, action) {
      const newValue = new Date(value);

      switch (action) {
        case 'date':
          return this.$moment(newValue).tz(this.timezone).format('DD/MM/YYYY');
        case 'time':
          return this.$moment(newValue).tz(this.timezone).format('HH:mm:ss');
        default:
          return;
      }
    },
    openPopup() {
      this.updateMenu({ activePopupPage: PopupPage.jackpotHelp });
    },
  },
};
</script>

<style lang="scss" scoped>
.notification-wrapper {
  height: 100%;
}
.notification__pop__header {
  display: flex;
  height: 40px;
  align-items: center;
}

h2 {
  font-size: 16px;
  line-height: 1.25;
  margin: 0;
}
.notification__pop__header {
  .close {
    display: none;
  }
}
.notification__pop__block {
  margin: auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .list {
    padding: 10px 20px;
    width: 100%;
    box-sizing: border-box;
    list-style: none;
    border-radius: 8px;
    margin-bottom: 8px;
    display: flex;
    align-items: top;
    @include desktop-only {
      &:first-child {
        margin-top: 50px;
      }
    }
    @include phone-only {
      align-items: flex-start;
      &:first-child {
        margin-top: 16px;
      }
    }
    .icon {
      height: 15px;
      width: 15px;
      margin-right: 10px;
      @include phone-only {
        margin: 10px 10px 0 0;
      }
    }
    &:last-child {
      border-bottom: none;
      margin-bottom: 60px;
    }
    .time {
      margin: 0 8px 0 0;
      padding: 0;
      font-size: 11px;
      font-weight: 500;
      line-height: 1.64;
      display: flex;
      flex-direction: column;
      min-width: 80px;
    }
    .desc-wrapper {
      display: flex;
      flex-direction: column;

      .desc {
        width: 100%;
        font-size: 12px;
        line-height: 1.38;
        font-weight: normal;
        line-height: 1.67;
        overflow-wrap: break-word;
      }

      .redirect-link {
        font-size: 10px;
        text-decoration: underline;
        cursor: pointer;
        font-weight: 600;
        color: #b2d6ea;
      }
    }

    img {
      height: 24px;
      width: 24px;
      color: #fff;
      margin-right: 5px;
    }
  }
}
</style>
